const mediaQuery = {
  mobile: "480px",
  tablet: "768px",
  laptop: "1024px",
  desktop: "1200px",
  big: "1600px",
};

export default mediaQuery;
